
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/player/[...name]",
      function () {
        return require("private-next-pages/player/[...name].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/player/[...name]"])
      });
    }
  